import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ProductComparison, ComparisonEmptyState } from '../components/products/ProductComparison';

interface ComparisonProduct {
  product: any;
  specs: Array<{ key: string; label: string; value: string; is_highlight?: boolean }>;
}

export function ComparisonPage() {
  // Get selected product IDs from localStorage
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem('comparison-products');
    if (stored) {
      try {
        setSelectedIds(JSON.parse(stored));
      } catch {
        setSelectedIds([]);
      }
    }
  }, []);

  // Fetch products
  const { data: products, isLoading } = useQuery({
    queryKey: ['products-list'],
    queryFn: async () => {
      const ids = selectedIds.join(',');
      if (!ids) return [];
      const res = await fetch(`/api/products?ids=${ids}`);
      if (!res.ok) throw new Error('Failed to fetch products');
      const json = await res.json();
      return json.data || [];
    },
    enabled: selectedIds.length > 0,
  });


  const comparisonProducts: ComparisonProduct[] = (products || []).map((product: any) => ({
    product,
    specs: product.specs || [],
  }));

  const handleRemove = (productId: string) => {
    const newIds = selectedIds.filter(id => id !== productId);
    setSelectedIds(newIds);
    localStorage.setItem('comparison-products', JSON.stringify(newIds));
  };

  const handleClear = () => {
    setSelectedIds([]);
    localStorage.removeItem('comparison-products');
  };

  if (selectedIds.length === 0) {
    return (
      <div className="container py-12">
        <ComparisonEmptyState />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="container py-12 flex flex-col items-center justify-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="text-gray-600">로딩 중...</p>
      </div>
    );
  }

  return (
    <div className="container py-8">
      <ProductComparison
        products={comparisonProducts}
        onRemove={handleRemove}
        onClear={handleClear}
      />
    </div>
  );
}
